import { useState } from 'react';

export const useActiveStandup = (): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
	const [isActiveStandup, setIsActiveStandup] = useState(false);

	return [isActiveStandup, setIsActiveStandup];
};
